import { RendezvousClient, type RendezvousStatus } from "@kitae/rendezvous/client";
import type { PeerRole, SignalPayload } from "@kitae/transfer-protocol";

export type SignalingStatus = RendezvousStatus;

export class SignalingClient {
  readonly #client: RendezvousClient;
  onSignal?: (payload: SignalPayload) => void | Promise<void>;
  onPeerChange?: (present: boolean) => void;
  onStatus?: (status: SignalingStatus) => void;
  onError?: (message: string) => void;

  constructor(url: string, roomId: string, secret: string, role: PeerRole) {
    this.#client = new RendezvousClient({
      url, roomId, secret,
      role: role === "receiver" ? "host" : "join",
      reconnect: true,
      reconnectDelayMs: 1_200,
    });
    this.#client.onStatus = (status) => this.onStatus?.(status);
    this.#client.onPeerChange = (present) => this.onPeerChange?.(present);
    this.#client.onPayload = (payload) => this.onSignal?.(payload as SignalPayload);
    this.#client.onError = (code) => {
      if (code === "unreachable") this.onError?.("La signalisation est momentanément indisponible.");
      else if (code !== "peer-unavailable") this.onError?.(`Erreur de signalisation (${code}).`);
    };
  }

  connect(): void {
    this.#client.connect();
  }

  async send(payload: SignalPayload): Promise<void> {
    await this.#client.send(payload);
  }

  close(): void {
    this.#client.close("Session terminée");
  }
}
